// src/components/SponsorCarousel.js
import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const sponsors = [
  { src: '/images/sponsors/EXCU.png', alt: 'Sponsor 1' },
  { src: '/images/sponsors/Sarmiento.png', alt: 'Sponsor 2' },
  { src: '/images/sponsors/instituto.png', alt: 'Sponsor 3' },
  { src: '/images/sponsors/Free.png', alt: 'Sponsor 4' },
];



const settings = {
  
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const SponsorCarousel = () => (
  <Box sx={{ py: 4 }}>
    <Slider {...settings}>
      {sponsors.map((sponsor, index) => (

        
        <Box key={index} px={2}>
          <Box
            sx={{
              background: 'rgba(255, 255, 255, 0.05)', // efecto glassmorphism
              borderRadius: 3,
              backdropFilter: 'blur(6px)',
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 150,
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              boxShadow: '0 0 10px rgba(255,255,255,0.1)',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 0 20px rgba(255,255,255,0.3)',
                
              },
            }}
            
          >

            
            <Box
              component="img"
              src={sponsor.src}
              alt={sponsor.alt}
              
              sx={{
                maxHeight: '100%',
                maxWidth: '100%',
                objectFit: 'contain',
                filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.4))', // suaviza bordes blancos
                
              }}
            />
          </Box>
        </Box>
      ))}
    </Slider>
  </Box>
);

export default SponsorCarousel;
